(ns app.front.view.group.admin.import.subs
  (:require [app.domain.util :as du]
            [app.front.entities :as entities]
            [re-frame.core-instrumented :as rf]))

(defn session-entity-signal [[_ session-id]]
  (rf/subscribe [::entities/entity session-id]))

(rf/reg-sub ::is-draft?
  session-entity-signal
  (fn [session _]
    (du/in-state? :import-session.state/draft session)))

(rf/reg-sub ::current-mappings
  session-entity-signal
  :-> :import-session/mappings)

(rf/reg-event-fx ::set-mapping-debounce
  (fn [_ [_ {:keys [authority-group-id session-id col-ix] :as params}]]
    {:dispatch-debounce {:id      (str "set-import-mapping" authority-group-id session-id col-ix)
                         :timeout 500
                         :action  :dispatch
                         :event   [::set-mapping params]}}))

(rf/reg-event-fx ::set-mapping
  (fn [_ [_ params]]
    {:comm/command {:command    :import/set-mapping
                    :data       params
                    :on-success [::entities/apply-changes]}}))
